type PdfIconProps = {
  style?: React.CSSProperties
  className?: string
}

export const PdfIcon: React.FC<PdfIconProps> = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.704 5.01a.57.57 0 0 1 .046.24v2.5H11.5V6.5H7.75A1.254 1.254 0 0 1 6.5 5.25V1.5h-5v15h10v1.25h-10A1.25 1.25 0 0 1 .25 16.5v-15A1.254 1.254 0 0 1 1.5.25h6.25a.568.568 0 0 1 .438.187l4.374 4.375a.57.57 0 0 1 .142.199ZM7.75 1.75v3.5h3.5l-3.5-3.5ZM5.875 9H2.75v6.25H4v-1.875h1.875a1.252 1.252 0 0 0 1.25-1.25V10.25A1.251 1.251 0 0 0 5.875 9ZM4 12.125V10.25h1.875v1.875H4Zm6.875 3.125a1.877 1.877 0 0 0 1.875-1.875v-2.5A1.877 1.877 0 0 0 10.875 9h-2.5v6.25h2.5Zm0-1.25h-1.25v-3.75h1.25a.626.626 0 0 1 .625.625v2.5a.625.625 0 0 1-.625.625Zm6.875-5v1.25h-2.5v1.25h1.875v1.25H15.25v2.5H14V9h3.75Z"
      fill="currentColor"
    />
  </svg>
)
